<template>
    <div class="help-displayer">
        <div
            class="help-displayer__icon"
            @click="isMobile ? showDrawerModal = true : null;"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16" height="16"
                viewBox="0 0 16 16"
            >
                <path
                    :fill="iconColor"
                    fill-rule="evenodd"
                    d="M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0ZM8,.8A7.2,7.2,0,1,0,15.2,8,7.2,7.2,0,0,0,8,.8Zm.767,5.707a.749.749,0,0,1,.7.669,2.444,2.444,0,0,1-.2.669L7.688,11.569c-.061.137-.046.228.061.228a4.634,4.634,0,0,0,1.429-.958.3.3,0,0,1,.289.365,4.627,4.627,0,0,1-3.192,1.809.783.783,0,0,1-.7-.608,1.863,1.863,0,0,1,.182-.654L7.338,7.966c.046-.122.046-.213-.03-.213a4.323,4.323,0,0,0-1.353.866.293.293,0,0,1-.243-.365A4.893,4.893,0,0,1,8.767,6.507Zm.654-3.329a.8.8,0,0,1,.851.9A1.163,1.163,0,0,1,9.117,5.306a.838.838,0,0,1-.9-.866A1.227,1.227,0,0,1,9.421,3.178Z"
                />
            </svg>
        </div>
        <div v-if="!isMobile" class="help-displayer__tooltip-container">
            <tooltip>
                <slot />
            </tooltip>
        </div>

        <drawer-modal v-model="showDrawerModal">
            <slot />
        </drawer-modal>
    </div>
</template>

<script>
import { isMobile } from "@u/helpers.js";
import DrawerModal from "../store/build/drawer-modal";
import Tooltip from "./tooltip";

export default {
    name: "HelpDisplayerIcon",
    components: {
        DrawerModal,
        Tooltip
    },
    props: {
        iconColor: {
            type: String,
            default: "#8d29a0"
        }
    },
    data() {
        return {
            isMobile: isMobile(),
            showDrawerModal: false
        }
    }
}
</script>

<style lang="scss" scoped>
.help-displayer {
    height: max-content;

    &__icon {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    &__icon:hover + &__tooltip-container {
        display: block;
    }

    &__tooltip-container {
        position: absolute;
        display: none;
    }
}
</style>